// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__38v3I","colMin":"styles_colMin__1-xEU","colCheckbox":"styles_colCheckbox__QYth4"};